<template>
  <div class="table-product">

    <div class="count">
      <span>Товаров найдено {{productsData.products_count}}</span>

      <div class="view_types">
        <div class="view_type" :class="[{active: catalog_view_type == 'table'}]">
          <img @click="change_view_type('table')" :src="require('@/assets/catalog/section/icons/vtype_table.svg')">
        </div>
        <div class="view_type" :class="[{active: catalog_view_type == 'list'}]">
          <img @click="change_view_type('list')" :src="require('@/assets/catalog/section/icons/vtype_table_i.svg')">
        </div>
      </div>
    </div>

    <div class="table" v-if="catalog_view_type == 'table'">
      <div class="head art">Артикул</div>
      <div class="head title">Модель</div>

      <div class="head" v-for="property in productsData.show_props_list" :key="property" v-html="property.NAME"></div>

      <div class="head">Наличие</div>
      <div class="head">Розничная<br>цена</div>
      <div class="head">Ваша<br>цена</div>
      <div class="head">Кол-во бонусов</div>
      <div class="head last">Купить</div>

      <template v-for="product in productsData.list" :key="product">
        <div class="val art">{{product.article}}</div>
        <div
            class="val title"
            @click="navigate(product)"
        >
          <span :title="product.name" class="text" v-html="product.name"></span>
        </div>

        <div class="val" v-for="property in product.props" :key="property" v-html="property.value"></div>

        <div class="val">{{product.quantity}}</div>
        <div class="val">{{product.price}}</div>
        <div class="val">{{product.custom_price}}</div>
        <div class="val b">{{product.bonuses}}</div>
        <div class="val last">
          <div class="fav" :class="[{ active : product.in_fav}]" @click="toggleFavorite(product)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10.5165 17.3417C10.2332 17.4417 9.7665 17.4417 9.48317 17.3417C7.0665 16.5167 1.6665 13.075 1.6665 7.24166C1.6665 4.66666 3.7415 2.58333 6.29984 2.58333C7.8165 2.58333 9.15817 3.31666 9.99984 4.45C10.8415 3.31666 12.1915 2.58333 13.6998 2.58333C16.2582 2.58333 18.3332 4.66666 18.3332 7.24166C18.3332 13.075 12.9332 16.5167 10.5165 17.3417Z" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="quantity-controller">
            <svg @click="minusBasket(product)" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input class="quantity_value" type="number" @input="setBasket($event.target.value, product)" :value="product.in_basket_quantity">
            <svg @click="plusBasket(product)" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 13.5V4.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </template>
    </div>

    <div class="fix_css" v-html="productsData.table_props_fix_css"></div>

    <div class="list" v-if="catalog_view_type == 'list'">
      <div class="head name">Наименования</div>
      <div class="head">Наличие</div>
      <div class="head">Розничная цена</div>
      <div class="head">Ваша цена</div>
      <div class="head">Кол-во бонусов</div>
      <div class="head last">Количество</div>

      <template v-for="item in productsData.list" :key="item">
        <div
            class="val title name"
            @click="navigate(item)"
        >
          <template v-if="item.image != null">
            <img @error="error_load_img(item)" :src="item.image">
          </template>
          <template v-if="item.image == null">
            <img :src="empty_image">
          </template>
          <div class="main">
            <span class="title" v-html="item.name"></span>
            <span class="article">Арт. {{item.article}}</span>
          </div>
        </div>
        <div class="val b"><span class="m_desc">Наличие</span><span>{{item.quantity}}</span></div>
        <div class="val"><span class="m_desc">Розничная цена</span><span>{{item.price}}</span></div>
        <div class="val"><span class="m_desc">Ваша цена</span><span>{{item.custom_price}}</span></div>
        <div class="val b"><span class="m_desc">Кол-во бонусов</span><span>{{item.bonuses}}</span></div>
        <div class="val last">
          <div class="fav" :class="[{active : item.in_fav}]" @click="toggleFavorite(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10.5165 17.3417C10.2332 17.4417 9.7665 17.4417 9.48317 17.3417C7.0665 16.5167 1.6665 13.075 1.6665 7.24166C1.6665 4.66666 3.7415 2.58333 6.29984 2.58333C7.8165 2.58333 9.15817 3.31666 9.99984 4.45C10.8415 3.31666 12.1915 2.58333 13.6998 2.58333C16.2582 2.58333 18.3332 4.66666 18.3332 7.24166C18.3332 13.075 12.9332 16.5167 10.5165 17.3417Z" stroke="#1B78BC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="quantity-controller">
            <svg @click="minusBasket(item)" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <input class="quantity_value" type="number" @input="setBasket($event.target.value, item)" :value="item.in_basket_quantity">
            <svg @click="plusBasket(item)" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4.5 9H13.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 13.5V4.5" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="val characteristics">
          <span class="desc">Характеристика:</span>
          <div class="values">
            <template  v-for="prop in item.props" :key="prop">
              <div v-if="prop.value != null" class="item" v-html="prop.name + ': ' + prop.value"></div>
              <svg v-if="prop.value != null" xmlns="http://www.w3.org/2000/svg" width="4" height="18" viewBox="0 0 4 18" fill="none">
                <circle cx="2" cy="9" r="2" fill="#1B78BC"/>
              </svg>
            </template>
          </div>
        </div>

      </template>
    </div>



    <div class="table-bottom">
      <span class="total">
        Показано {{productsData.show_products_count}} из {{productsData.products_count}} результатов
      </span>

      <div class="pagination">
        <svg
            @click="change_page_prev()"
            :class="[{not_active: productsData.current_page == 1}]"
            xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
          <path d="M10 17L6 12L10 7" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <div class="page" @click="change_page(page)"
             v-for="page in productsData.pages" :key="page"
             :class="[{current: page == productsData.current_page}]"
        >
          <span>{{page}}</span>
        </div>

        <svg
            @click="change_page_next()"
            :class="[{not_active: productsData.current_page == productsData.pages_count}]"
            xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
          <path d="M6 7L10 12L6 17" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

import axios from "axios";

export default {
  name: 'TableProduct',
  props : {
    productsData : Object
  },
  components: {

  },
  data() {
    return{
      catalog_view_type : localStorage.getItem("catalog_view_type") == null ? "table"
          : localStorage.getItem("catalog_view_type"),
      empty_image : require('@/assets/catalog/product/empty.svg')
    }
  },
  mounted() {

  },
  methods : {
    error_load_img: async function(product) {
      product.image = this.empty_image;
    },
    change_view_type(view_type) {
      localStorage.setItem("catalog_view_type", view_type);
      this.catalog_view_type = view_type;
      //this.$router.push({query: {q : this.$route.query.q, view_type : view_type, filter: this.$route.query.filter, sort: this.$route.query.sort, price: this.$route.query.price}})
    },
    toggleFavorite : async function(product) {
      if(!product.in_fav) {
        let res = await axios.get(window.api_url + "favorite/add?id="+product.id);
        console.log(res);
        product.in_fav = true;
      }
      else {
        let res = await axios.get(window.api_url + "favorite/remove?id="+product.id);
        console.log(res);
        product.in_fav = false;
      }
    },
    plusBasket : async function(product) {
      let qnt = product.in_basket_quantity + 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;

      this.$emit("basket_changed");
    },
    setBasket: async function(qnt, product) {
      if(!(parseInt(qnt) >= 0)) {return;}

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;
      this.$emit("basket_changed");
    },
    minusBasket : async function(product) {
      if(product.in_basket_quantity <= 0) {return;}
      let qnt = product.in_basket_quantity - 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;

      this.$emit("basket_changed");
    },
    navigate : function(product) {
      this.$router.push(
          {
            name:'catalog_product',
            params: {
              section: product.section_code,
              product: product.id
            }
          }
      )
    },
    change_page : function(page) {
      if(page == "...") {return;}
      this.$router.push({query: {q : this.$route.query.q, page : page, filter: this.$route.query.filter, sort: this.$route.query.sort, price: this.$route.query.price}})
    },
    change_page_prev : function() {
      let page = this.productsData.current_page - 1;
      if(page < 1) {page = 1;}
      this.$router.push({query: {q : this.$route.query.q, page : page, filter: this.$route.query.filter, sort: this.$route.query.sort, price: this.$route.query.price}})
    },
    change_page_next : function() {
      let page = this.productsData.current_page + 1;
      if(page > this.productsData.pages_count) {page = this.productsData.pages_count;}
      this.$router.push({query: {q : this.$route.query.q, page : page, filter: this.$route.query.filter, sort: this.$route.query.sort, price: this.$route.query.price}})
    },
  }
}
</script>

<style scoped>

.count {
  margin-bottom: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.count span {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.view_types {
  display: flex;
  background: var(--White);
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 2px;
}

.view_types .view_type {
  padding: 7px;
  width: 16px;
  height: 16px;
}

.view_types .view_type img {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.view_types .view_type.active {
  border-radius: 6px;
  background: var(--BG, #F8F8F8);
}



.table {
  display: grid;
  grid-template-columns: auto auto auto max-content max-content 1fr 1fr;
  border-top: 1px solid var(--Border, #EDEDED);
  border-left: 1px solid var(--Border, #EDEDED);
  background: var(--White);
  border-radius: 8px 8px 0px 0px;
  overflow: auto;
}

.table .head {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  border-bottom: 1px solid var(--Border, #EDEDED);
  border-right: 1px solid var(--Border, #EDEDED);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  text-align: center;
}

.table .head.title {
  flex-direction: row;
  justify-content: left;
  text-align: left;
}

.table .val {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
  border-bottom: 1px solid var(--Border, #EDEDED);
  border-right: 1px solid var(--Border, #EDEDED);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  text-align: center;
}

.table .val.b {
  color: var(--Blue, #1B78BC);
}

.table .val.title {
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  justify-content: left;
}

.table .val.title .text {
  -webkit-line-clamp: 1;
  line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.table .val.last {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table .val.last .fav {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.table .val.last .fav.active svg path{
  fill: var(--Blue);
}

.table .val.last .quantity-controller {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  height: 38px;
  width: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.table .val.last .quantity-controller .quantity_value {
  width: 15px;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
}

.table .val.last .quantity-controller svg{
  cursor: pointer;
}



.list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  border-top: 1px solid var(--Border, #EDEDED);
  border-left: 1px solid var(--Border, #EDEDED);
  background: var(--White);
  border-radius: 8px 8px 0px 0px;
}

.list .head {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  border-bottom: 1px solid var(--Border, #EDEDED);
  border-right: 1px solid var(--Border, #EDEDED);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 18px;
  text-align: center;
}

.list .head.name {
  justify-content: left;
  align-items: flex-start;
}

.list .val {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 18px;
  text-align: center;
}

.list .val.b {
  color: var(--Blue, #1B78BC);
}

.list .val.title {
  font-weight: 500;
  cursor: pointer;
}

.list .val.title.name {
  justify-content: start;
  gap: 12px;
  width: 346px;
}

.list .val.title.name img {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  width: 60px;
  min-width: 60px;
  height: 60px;
  box-sizing: border-box;
  background: #fff;
}

.list .val.title.name .main{
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: start;
  align-items: start;
  text-align: left;
}

.list .val.title.name .main .title{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  word-break: break-word;
}

.list .val.title.name .main .article{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
}

.list .val.last {
  display: flex;
  align-items: center;
  gap: 6px;
  border-right: 1px solid var(--Border, #EDEDED);
}

.list .val.characteristics {
  grid-column: 1/7;
  display: flex;
  justify-content: start;
  border-bottom: 1px solid var(--Border, #EDEDED);
  border-right: 1px solid var(--Border, #EDEDED);
  padding-top: unset;
  gap: 24px;
}

.list .val.characteristics .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.list .val.characteristics .values {
  display: flex;
  gap: 12px;
}

.list .val.characteristics .values .item{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.list .val.characteristics .values svg:last-child {
  display: none;
}

.list .val.last .fav {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.list .val.last .fav.active svg path{
  fill: var(--Blue);
}

.list .val.last .quantity-controller {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  height: 38px;
  width: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.list .val.last .quantity-controller .quantity_value {
  width: 15px;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
}

.list .val.last .quantity-controller svg{
  cursor: pointer;
}



.table-bottom {
  padding: 16px 20px;
  border: 1px solid var(--Border, #EDEDED);
  border-top: unset;
  background: var(--White);
  border-radius: 0px 0px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-bottom .total {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.table-bottom .pagination {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.table-bottom .pagination svg {
  cursor: pointer;
}

.table-bottom .pagination svg.not_active {
  opacity: 0.5;
}

.table-bottom .pagination span{
  color: var(--Gray, #656565);
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}

.table-bottom .pagination .page {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  height: 30px;
  width: 30px;
}

.table-bottom .pagination .page.current {
  background: var(--Blue, #1B78BC);
  color: var(--White, #FFF);
}

.table-bottom .pagination .page.current span {
  color: var(--White, #FFF);
}




/*MOBILE*/
.list .val span.m_desc {
  display: none;
}

@media (max-width: 1250px)
{
  .table-product {

  }

  .table-product .count{
    /*display: none;*/
  }

  .table-product .table {
    overflow: auto;
  }

  .table-bottom .pagination {
    gap: 4px;
  }

  .table-bottom .pagination .page {
    height: 20px;
    width: 20px;
    border-radius: 6px;
  }

  .table-bottom .pagination .page span{
    font-size: 12px;
  }

  .table-product .table-bottom {
    flex-direction: column;
    gap: 14px;
  }



  .list .head {
    display: none;
  }

  .list .val {
    grid-column: 1/7;
    justify-content: space-between;
    padding: 0px 18px 10px 18px;
  }

  .list .val span.m_desc {
    display: block;
    color: var(--Gray, #656565);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .list .val.title.name {
    width: auto;
    padding: 18px 18px 14px 18px;
  }

  .list .val.characteristics {
    display: none;
  }

  .list .val.last {
    border-bottom: 1px solid var(--Border, #EDEDED);
    border-right: unset;
    padding: 12px 18px 18px 18px;
  }
}
</style>


